import { isUndefined } from 'util';

export class SingleSelectItem {
  isSelected = false;
  disable = false;
  data: any;
  text = '';

  constructor(data?: any, text?: string) {
    if (!isUndefined(data)) {
      this.data = data;
    }
    if (!isUndefined(text)) {
      this.text = text;
    }
  }
}
